import React, {useEffect, useState} from 'react';
import { CdsFieldLabel, useFormContext } from 'clayco-component-library/lib';
import { Form } from 'react-bootstrap';

// Modified form input for numbers without area codes
const PhoneNumberInput = ({label, required = false, key, value,
    onChange,
    helpText,
    pattern,
    placeholder,
    name,
    initialValue = '',
    optionalValidityText,
    autoComplete = 'off',
    controlled = false,
    disabled = false,
    showTooltip = false,
    international = false,
    before,
    after,
    classes
   }) => {
      const tooltipHeader = "";
      const tooltipBody = <></>;
      const type = "";
  
      const { register, watch, formState, setValue, trigger } = useFormContext()
  
      const [objValue, setObjValue] = useState(null)
      const watcher = watch(name)
      let obj = formState.errors[name]
    
      const array = name.substr(0, name.indexOf('['))
      if (array.length > 0) {
        const optionalName = name.replace('.', '?.')
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null
      }
  
      const refreshObj = () => {
          if (array.length > 0) {
            const optionalName = name.replace('.', '?.')
            obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null
          }
        }
  
    const formatUsPhone = (value) => {
        return value
            .match(/\d*/g)
            .join('')
            .match(/(\d{0,3})(\d{0,4})/)
            .slice(1)
            .join('-')
            .replace(/-*$/g, '')
        }
    
    const formatInternationalPhone = (value) => {
      return value
        .match(/\d*/g)
        .join('')
        .replace(/-*$/g, '')
    }
  
      useEffect(() => {
          if (!watcher) setObjValue(null)
          else setObjValue(watcher)
      
          refreshObj()
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [watcher])

        useEffect(() => {
          if (initialValue != null) {
                setValue(name, formatUsPhone(initialValue))
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
  
        const change = (e) => {
          // clear custom validity so that it can properly reassess
          e.currentTarget.setCustomValidity('');
  
          // format like US number or Global 
          if (!international)
            e.target.value = formatUsPhone(e.target.value);
          else
            e.target.value = formatInternationalPhone(e.target.value);
  
          if (e)
              setValue(name, e.target.value);
  
          if (onChange)
              onChange(e.target.value);
  
          trigger(name);
        };
  
      return(
          <>
          <div className="area-code-field">
              <Form.Group>
                  <CdsFieldLabel label={label || ''} required={required} showTooltip={showTooltip} tooltipHeader={tooltipHeader} tooltipBody={tooltipBody} />
                  <div className="input-group">
                      {before && <span className="input-group-text">{before}</span>}
                      {/* 
                          If CdsInputField is specified as controlled={true},
                          then the value prop will be passed down to the component.
                          Otherwise, no value prop is passed down to the
                          uncontrolled component.
                      */}
                      {
                          controlled ?
                         <Form.Control
                          key={key}
                          value={value}
                          autoComplete={autoComplete}
                          className={classes}
                          required={required}
                          placeholder={placeholder}
                          type={type}
                          maxLength={20}
                          pattern={pattern}
                          {...register(name)}
                          isInvalid={!!obj}
                          disabled={disabled}
                          onChange={change}
                          onInvalid={
                            (e)=> optionalValidityText ? 
                            e.currentTarget.setCustomValidity(optionalValidityText) :
                            e.currentTarget.setCustomValidity('')}
                        ></Form.Control>
                        :
                        <Form.Control
                          key={key}
                          autoComplete={autoComplete}
                          className={classes}
                          required={required}
                          placeholder={placeholder}
                          type={type}
                          maxLength={20}
                          pattern={pattern}
                          {...register(name)}
                          isInvalid={!!obj}
                          disabled={disabled}
                          onChange={change}                          
                          onInvalid={
                            (e)=> optionalValidityText ? 
                            e.currentTarget.setCustomValidity(optionalValidityText) :
                            e.currentTarget.setCustomValidity('')}
                        ></Form.Control>  }
                        {after && <span className="input-group-text">{after}</span>}
                      </div>
                      <Form.Text className="cds-text-light-italic">{helpText}</Form.Text>
                      <Form.Control.Feedback type="invalid">{obj?.message}</Form.Control.Feedback>
              </Form.Group>
          </div>
          </>
      )
  }

  export default PhoneNumberInput;